(function(window, $){
  if ($('body').hasClass('page-template-blog-listing')) {

    const animationDuration = 300;
    const data = blogHeroJSON;
    let activeIndex = 0;
    let filters = {};
    const maxItems = $('.full-width-hero__navigation__item').length - 1;

    const $title = $('.full-width-hero__content__title');
    const $author = $('.full-width-hero__content__author');
    const $category = $('.full-width-hero__content__category');
    const $date = $('.full-width-hero__content__category__date');
    const $minRead = $('.full-width-hero__content__category__min-read');

    $('.full-width-hero__navigation__item').on('click', handleNavClick);
    $('.blog-listing__filter__pill').on('click', handleFilterClick);
    $('.blog-listing__filter__clear').on('click', handleClearFilters);
    $('.blog-listing__filter-mobile select').on('change', handleMobileFilterChange);

    if (window.location.search.substr(1)) {
      $(`.blog-listing__filter__pill[data-category="${window.location.search.substr(1).split('=')[1]}"]`).click();
    }

    let carouselInterval = null;

    function handleNavClick({index}){
      activeIndex = typeof index === 'undefined' ?
          $(this).index() :
          index;
      $('.full-width-hero__navigation__item--active').removeClass('full-width-hero__navigation__item--active');
      $('.full-width-hero__navigation__item').eq(activeIndex).addClass('full-width-hero__navigation__item--active');

      $('.full-width-hero__content__inner').animate({opacity: 0}, animationDuration, () => {
        const {
          author,
          category,
          category_slug,
          date,
          link,
          post_title,
          read_mins,
          target,
          thumbnail,
        } = data[activeIndex];

        $title.text(post_title);
        $title.attr('href', link);
        $title.attr('target', target);
        $author.text(author);
        $category.text(category);
        $category.attr({
          class: `full-width-hero__content__category full-width-hero__content__category--${category_slug}`
        });
        $date.text(date);
        $minRead.text(`${read_mins} min read`);

        const $initialImage = $('.full-width-hero__image');
        const $newImage = $initialImage.clone();
        $newImage.find('img').attr({src: thumbnail});
        $newImage.css({opacity: 0});

        $initialImage.parent().append($newImage);

        $newImage.animate({opacity: 1}, animationDuration, () => {
          $initialImage.remove();
        });
        $('.full-width-hero__content__inner').animate({opacity: 1}, animationDuration);
      });

      restartCarouselInterval();
    }

    function handleFilterClick(){
      $(this).toggleClass('blog-listing__filter__pill--active');
      const filterCategory = $(this).data('category');

      if (filters[filterCategory]) {
        delete filters[filterCategory];
      } else {
        filters[filterCategory] = true;
      }

      filterGridItems();
    }

    function filterGridItems(){
      $('.blog-listing__grid__item--hidden').removeClass('blog-listing__grid__item--hidden');
      const filterKeys = Object.keys(filters);

      if (filterKeys.length === 0) {
        handleClearFilters();
      } else {
        $('.blog-listing__grid__item').each(function () {

          const category = $(this).data('category');
          if (filterKeys.indexOf(category) === -1) {
            $(this).addClass('blog-listing__grid__item--hidden');
          }
        })
      }
    }

    function handleMobileFilterChange(){
      filters = !$(this).val() ? {} : {
        [$(this).val()]: true
      }
      filterGridItems();
    }

    function handleClearFilters(){
      $('.blog-listing__grid__item--hidden').removeClass('blog-listing__grid__item--hidden');
      $('.blog-listing__filter__pill--active').removeClass('blog-listing__filter__pill--active');
      filters = {};
    }

    function restartCarouselInterval() {
      clearInterval(carouselInterval);
      carouselInterval = setInterval(() => {
        if (activeIndex++ >= maxItems || activeIndex < 0) {
          activeIndex = 0;
        }
        handleNavClick({index: activeIndex})
      }, 8000);
    }

    restartCarouselInterval();

  }
})(window, jQuery);